import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=412a4a52"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Delete.vue?vue&type=custom&index=0&blockType=sty&Buttonle=true"
if (typeof block0 === 'function') block0(component)

export default component.exports